import adminApiClient from '@/services/admin/api.admin';
import ADMIN_API_ENDPOINTS from '@/services/admin/endpoints.admin';
async function list(params = {}) {
    // Convertir params a Record<string, unknown> para compatibilidad con apiClient
    const queryParams = {};
    if (params.limit != null)
        queryParams.limit = params.limit;
    if (params.offset != null)
        queryParams.offset = params.offset;
    if (params.location_id != null)
        queryParams.location_id = params.location_id;
    if (params.user_id != null)
        queryParams.user_id = params.user_id;
    return adminApiClient.get(ADMIN_API_ENDPOINTS.LOCATION_REVIEWS.BASE, queryParams);
}
async function get(id) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_REVIEWS.BY_ID(id);
    return adminApiClient.get(url);
}
async function create(body) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_REVIEWS.BASE;
    return adminApiClient.post(url, body);
}
async function update(id, body) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_REVIEWS.BY_ID(id);
    return adminApiClient.put(url, body);
}
async function remove(id) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_REVIEWS.BY_ID(id);
    return adminApiClient.delete(url);
}
async function getByLocation(locationId) {
    const url = ADMIN_API_ENDPOINTS.LOCATION_REVIEWS.BY_LOCATION(locationId);
    return adminApiClient.get(url);
}
export default {
    list,
    get,
    create,
    update,
    remove,
    getByLocation
};
